module.exports = __webpack_public_path__ + "img/tabs1(2).c76baa98.png";